module.exports = __webpack_public_path__ + "img/seafood-homepage-hero.c8288912.jpg";